module.exports = "/images/milano-11.jpg";